'use client';

import {isPlainObject, objValueAsArray, objValueAsInt, objValueAsString} from "@utils/object";
import Link from "next/link";
import {currentUrlServerSide} from "@utils/url-server";
import {generateExcerptServerSide} from "@utils/string-server";
import {LINK_NEWS_DETAILS} from "@constants/page-links/news";

const ENTITY_NAME = 'News';

const LINK_DETAILS = LINK_NEWS_DETAILS;

const NewsList = ({
   queryParams,
   postsSearchData
}) => {
   
   postsSearchData = isPlainObject(postsSearchData) ? postsSearchData : {};
   
   const total = objValueAsInt(postsSearchData, 'total', 0);
   const per_page = objValueAsInt(postsSearchData, 'per_page', 0);
   const current_page = objValueAsInt(postsSearchData, 'current_page', 0);
   
   const first_page = 1;
   const last_page = objValueAsInt(postsSearchData, 'last_page', 0);
   
   
   const posts = objValueAsArray(postsSearchData, 'data', []);
   
   const prev_page_url = objValueAsString(postsSearchData, 'prev_page_url', '');
   const next_page_url = objValueAsString(postsSearchData, 'next_page_url', '');
   
   if (total === 0) return (
      <div className="blog-posts-list">
         <div className="alert alert-warning text-center mb-0 p-3 text-center">
            No {ENTITY_NAME} found
         </div>
      </div>
   );
   
   return (
      <div className="blog-posts-list">
         
         
         {posts?.map((post, index) => (
            <article className="border rounded mb-3 post-block list-post-block" key={index}>
               <div className="p-4">
                  <header className="mb-1">
                     <h3 className="title m-0">
                        <Link
                           className="text-decoration-none blog-list-post-title"
                           href={LINK_DETAILS + post.slug}>
                           {post.title}
                        </Link>
                     </h3>
                  </header>
                  
                  <p className="d-flex justify-content-start align-items-center gap-3">
                      <span>
                        <strong>By: </strong> <Link className="text-decoration-none author-name" href={currentUrlServerSide(queryParams,{author : post.author?.author_id})}>{post.author.full_name}</Link>
                     </span>
                     
                     <span>
                        <strong>Posted: </strong> <span>{post.created_at_diff}</span>
                     </span>
                  </p>
                  
                  <div className="content mt-3">
                     {
                        post.excerpt || generateExcerptServerSide(post.content, 255)
                     }</div>
                  
                  <footer className="mt-3">
                     
                     {post.categories && Array.isArray(post.categories) && post.categories.length > 0 && (
                        <div className="categories d-flex justify-content-start align-items-center gap-2">
                           
                           {post?.categories?.map((category, index) => (
                              <Link
                                 key={index}
                                 href={currentUrlServerSide(queryParams,{categories : category.category_id})}
                              >
                              <span className="badge bg-success" >{category.category_name}</span>
                              </Link>
                           ))}
                        
                        </div>
                     )}
                  
                  
                  </footer>
               
               </div>
            </article>
         ))}
         
         {total > 0 && total > per_page && (
            <div className="row pagination">
               <div className="col p-4 d-flex justify-content-between align-items-center">
                  
                  {current_page - 1 >= 1 ?
                     (
                        <>
                           <Link
                              href={currentUrlServerSide(queryParams,{page: current_page - 1})}
                              className="btn btn-outline-primary">
                              <i className="fa fa-arrow-left"></i> Previous
                           </Link>
                        </>
                     ) : (
                        <>
                           <button
                              className="btn btn-outline-secondary disabled"
                              disabled={true}
                           >
                              <i className="fa fa-arrow-left"></i> Previous
                           </button>
                        </>
                     )}
                  
                  {current_page + 1 <= last_page ? (
                     <>
                        <Link
                           href={currentUrlServerSide(queryParams,{page: current_page + 1})}
                           className="btn btn-outline-primary">
                           Next <i className="fa fa-arrow-right"></i>
                        </Link>
                     </>
                  ) : (
                     <>
                        <button
                           className="btn btn-outline-secondary disabled"
                           disabled={true}
                        >
                           Next <i className="fa fa-arrow-right"></i>
                        </button>
                     </>
                  )}
                  
                  
                  
               
               </div>
            </div>
         )}
         
         {/*<pre style={{wordBreak: 'break-all', whiteSpace: 'pre-wrap'}}>{JSON.stringify(postsSearchData, null, 2)}</pre>*/}
      
      
      </div>
   )
   
}

export default NewsList;